import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'
class Excel {
  // 导出商品表格
  getGoodsExcel(options) {
    let url = `/api/download/goods?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res)
    })
  }
  // 导出客户表格
  getCustomerExcel(options) {
    let url = `/api/download/cus?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res)
    })
  }
  // 导出订单表格
  getOrderExcel(options) {
    let url = `/api/download/order?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res)
    })
  }
  // 导出购样单表格
  getSampleExcel(options) {
    let url = `/api/download/sample/order?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res)
    })
  }
  // 导出退单表格
  getRefundOrderExcel(options) {
    let url = `/api/download/refund/order?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res)
    })
  }
  // 导出价格表格
  getPriceExcel(options) {
    let url = `/api/download/prices?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res)
    })
  }
  // 导入价格表格
  postUploadPriceExcel(data) {
    let url = `/api/upload/prices`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 导出返修单表格
  getRepairExcel(options) {
    let url = `/api/download/repair?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res)
    })
  }
  // 商品价格导出报表
  getGoodsPriceExcel(options) {
    let url = `/api/download/supplier/prices?`
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: 'blob' }).then(res => {
      return Promise.resolve(res)
    })
  }
}

export default Excel;
